import React, { forwardRef, useImperativeHandle, useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DeleteIcon from '../../static/image/deleteIcon.svg';
import { setValueCommonIssue } from '../../redux/productSlice';
import CustomInput from '../../components/customInput/CustomInput';
import CommonDeleteModal from '../../components/commonDeleteModal/CommonDeleteModal';

const CommonIssue = forwardRef(({ language }, ref) => {
  const dispatch = useDispatch();
  const productState = useSelector((state) => state.product);
  const product = productState.data || {};

  const commonIssueData = product.commonIssue || product.contentData?.commonIssue || {};
  const commonIssues = commonIssueData.items || [];
  const commonIssueTitle = commonIssueData.title || '';

  const [showDeleteIssueModal, setShowDeleteIssueModal] = useState(false);
  const [issueToDelete, setIssueToDelete] = useState(null);

  const PLACEHOLDER_CONFIG = {
    title: {
      EN: "Enter common issue title EN",
      CN: "Enter common issue title CN"
    },
    title1: {
      EN: "Enter title1 EN",
      CN: "Enter title1 CN"
    },
    description1: {
      EN: "Enter description1 EN",
      CN: "Enter description1 CN"
    },
    title2: {
      EN: "Enter title2 EN",
      CN: "Enter title2 CN"
    },
    description2: {
      EN: "Enter description2 EN",
      CN: "Enter description2 CN"
    },
    retainIssue: {
      EN: "At least retain one common issue EN",
      CN: "At least retain one common issue CN"
    }
  };

  const addGroup = useCallback(() => {
    const newItems = [
      ...commonIssues,
      {
        title: '',
        description: '',
        title1: '',
        description1: ''
      }
    ];
    dispatch(setValueCommonIssue({
      value: {
        ...commonIssueData,
        items: newItems
      }
    }));
  }, [commonIssueData, commonIssues, dispatch]);

  const deleteGroup = useCallback((index) => {
    if (commonIssues.length <= 1) {
      alert(PLACEHOLDER_CONFIG.retainIssue[language]);
      return;
    }
    setIssueToDelete(index);
    setShowDeleteIssueModal(true);
  }, [commonIssueData, commonIssues, language, dispatch]);

  const handleConfirmDeleteIssue = useCallback(() => {
    if (issueToDelete !== null) {
      const newItems = commonIssues.filter((_, i) => i !== issueToDelete);
      dispatch(setValueCommonIssue({
        value: {
          ...commonIssueData,
          items: newItems
        }
      }));
    }
    setShowDeleteIssueModal(false);
    setIssueToDelete(null);
  }, [commonIssueData, commonIssues, issueToDelete, dispatch]);

  const updateCommonIssue = useCallback((field, value) => {
    dispatch(setValueCommonIssue({
      value: {
        ...commonIssueData,
        [field]: value
      }
    }));
  }, [commonIssueData, dispatch]);

  const updateIssueItem = useCallback((index, field, value) => {
    const newItems = commonIssues.map((item, i) =>
      i === index ? { ...item, [field]: value } : item
    );
    dispatch(setValueCommonIssue({
      value: {
        ...commonIssueData,
        items: newItems
      }
    }));
  }, [commonIssueData, commonIssues, dispatch]);

  const validateAllCommonIssues = useCallback(() => {
    return {};
  }, []);

  useImperativeHandle(ref, () => ({
    addGroup,
    validateAllCommonIssues
  }));

  return (
    <div className="tab-package-container">
      <div className="domain-group">
        <div className='package-input'>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '8px'
          }}>
            <label>Title:</label>
          </div>
          <CustomInput
            type="text"
            value={commonIssueTitle}
            onChange={(e) => updateCommonIssue('title', e.target.value)}
            placeholder={PLACEHOLDER_CONFIG.title[language]}
            customStyle={{ width: '73%' }}
          />
        </div>
      </div>

      <div
        style={{
          height: '0.5px',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          margin: '25px -40px',
          width: 'calc(100% + 80px)',
          display: 'block',
          boxSizing: 'border-box'
        }}
      />

      {commonIssues.map((issue, index) => (
        <div key={index}>
          <div className="domain-group">
            <div className='package-input'>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '8px'
              }}>
                <label>Title1:</label>
              </div>
              <CustomInput
                type="text"
                value={issue.title || ''}
                onChange={(e) => updateIssueItem(index, 'title', e.target.value)}
                placeholder={PLACEHOLDER_CONFIG.title1[language]}
                customStyle={{ width: '73%' }}
              />
              <button
                className="icon-btn"
                onClick={() => deleteGroup(index)}
              >
                <img src={DeleteIcon} alt="Delete" className="campaign-delete-icon" />
              </button>
            </div>

            <div className='package-input'>
              <label>Description1:</label>
              <textarea
                placeholder={PLACEHOLDER_CONFIG.description1[language]}
                value={issue.description}
                onChange={(e) => updateIssueItem(index, 'description', e.target.value)}
                rows={3}
                style={{ width: '73%' }}
              />
            </div>

            <div className='package-input'>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '8px'
              }}>
                <label>Title2:</label>
              </div>
              <CustomInput
                type="text"
                value={issue.title1}
                onChange={(e) => updateIssueItem(index, 'title1', e.target.value)}
                placeholder={PLACEHOLDER_CONFIG.title2[language]}
                customStyle={{ width: '73%' }}
              />
            </div>

            <div className='package-input'>
              <label>Description2:</label>
              <textarea
                placeholder={PLACEHOLDER_CONFIG.description2[language]}
                value={issue.description1 || ''}
                onChange={(e) => updateIssueItem(index, 'description1', e.target.value)}
                rows={3}
                style={{ width: '73%' }}
              />
            </div>
          </div>

          {index !== commonIssues.length - 1 && (
            <div
              style={{
                height: '0.5px',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                margin: '25px -40px',
                width: 'calc(100% + 80px)',
                display: 'block',
                boxSizing: 'border-box'
              }}
            />
          )}
        </div>
      ))}

      <CommonDeleteModal
        show={showDeleteIssueModal}
        onHide={() => {
          setShowDeleteIssueModal(false);
          setIssueToDelete(null);
        }}
        onConfirm={handleConfirmDeleteIssue}
        title="Delete Common Issue"
        instruction="Are you sure you want to delete this common issue item?"
      />
    </div>
  );
});

export default CommonIssue;